import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { colors, text } from '../../core/styles/theme/default';
import { rem } from 'polished';
import SvgEchIconArrowUp from '../../primitives/IconSVG/static/EchIconArrowUp';

const bounce = keyframes`
  from {
    transform: translate3d(0, -4px, 0);
  }

  55% {
    transform: translate3d(0, 4px, 0);
  }

  60% {
    transform: translate3d(0, 6px, 0);
  }

  65% {
    transform: translate3d(0, 8px, 0);
  }

  85% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate3d(0, -100px, 0);
  }
`;

const StyledIcon = styled(SvgEchIconArrowUp)`
  width: ${rem(24)};
  height: ${rem(24)};
  margin-right: ${rem(16)};
  transform: translateY(${rem(-4)});
`;

const StyledButton = styled.button`
  position: relative;
  ${text.p3};
  display: flex;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${colors.nightBlue900};
  margin: 0 auto;
  padding: ${rem(10)} 0;
  transform: translateX(${rem(-20)});

  &:hover {
    ${StyledIcon} {
      animation: ${bounce} 1s ease-out;
      animation-fill-mode: forwards;
    }
  }

  ${({ theme }) => theme?.stylesExtension?.scrollToTop?.button};
`;

const ScrollToTop = ({ backToTopText }: { backToTopText: string }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <StyledButton onClick={scrollToTop}>
      <StyledIcon />
      {backToTopText}
    </StyledButton>
  );
};

export default ScrollToTop;
